/**
 * Homepage selectors
 */

import { createSelector } from 'reselect';

const selectHome = (state) => state.get('home');

const selectLoading = () => createSelector(
  selectHome,
  (homeState) => homeState.get('loading')
);

const selectToken = () => createSelector(
  selectHome,
  (homeState) => homeState.get('token')
);

const selectUsers = () => createSelector(
  selectHome,
  (homeState) => homeState.get('users')
);

const selectCSRFToken = () => createSelector(
  selectHome,
  (homeState) => homeState.get('csrfToken')
);

const selectTermsResponse = () => createSelector(
  selectHome,
  (homeState) => homeState.get('termsResponse')
);

const selectAcceptTerms = () => createSelector(
  selectHome,
  (homeState) => homeState.get('acceptTerms')
);

const selectAgreeState = () => createSelector(
  selectHome,
  (homeState) => homeState.get('isVisible')
);

export {
  selectHome,
  selectLoading,
  selectToken,
  selectUsers,
  selectCSRFToken,
  selectAcceptTerms,
  selectTermsResponse,
  selectAgreeState,
};
